import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/providers/navigation.service';
import { EditAccessComponent } from '../new-v2-component/edit-access/edit-access.component';
import { MatDialog } from '@angular/material/dialog';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { ApiService } from 'src/app/providers/api.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-access-control',
  templateUrl: './access-control.component.html',
  styleUrls: ['./access-control.component.scss']
})
export class AccessControlComponent implements OnInit ,OnDestroy {
  apisub: Subscription
  functionalityList:any = []
  constructor(private navservice:NavigationService, private dialog: MatDialog,private ls: LoaderServiceService, private apiservice: ApiService, private route:ActivatedRoute) { 
     this.navservice.hideSidebarAndNav = false;

     this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_FUNCTIONALITY_BY_EMPLOYEE_ID){
        this.functionalityList = []
        if(resdata.result){
          this.functionalityList = resdata.result
        }
      }
      this.loader = false
      this.ls.showLoader = false
     })
  }
openeditaccess(){
    let dref = this.dialog.open(EditAccessComponent, {
      width: "500px",
      data:{
        data: this.functionalityList,
        employeeHash: this.employeeHash
      }
    });

    dref.afterClosed().subscribe(data => {
      if(data){
            this.apiservice.getFunctionalityByEmployeeId(this.employeeHash)

      }
    })
}


  employeeHash:any
  loader: boolean = false
  ngOnInit(): void {
    this.loader = true
    this.route.queryParams.subscribe(data =>{
      if(data){
        this.employeeHash = data.employeeHash
      }
    })
    this.ls.showLoader = true
    this.apiservice.getFunctionalityByEmployeeId(this.employeeHash)
  }
ngOnDestroy(): void {
  this.apisub.unsubscribe()
}
}
